export default function reducer(state = {
  pending: false,
  contact: {}
}, action) {
  switch (action.type) {
    case 'START_REGISTRATION_INTERNAL': {
      return {...state, pending: true, internal: true};
    }
    case 'START_REGISTRATION_EXTERNAL': {
      return {...state, pending: true, internal: false};
    }
    case 'SET_REGISTRATION_TOKEN': {
      return {
        ...state,
        registration_token: action.payLoad.registration_token
      };
    }
    case 'FINISH_REGISTRATION': {
      return {
        ...state,
        pending: false,
        internal: undefined,
        addMore: false,
        registration_token: ''
      };
    }
    case 'ADD_MORE_REGISTRATION': {
      return {
        ...state,
        pending: true,
        addMore: true,
        pending_user_id: action.payLoad.pending_user_id
      };
    }
    case 'NEW_CONTACT_FULFILLED': {
      return {
        ...state,
        contact: action.payLoad
      };
    }
    default:
  }

  return {...state};
}
